import { clientService } from "../client/clientService";

export const ENDPOINTS = {
  AUTH: {
    LOGIN: "/api/auth/login",
    REQUEST_PASSWORD_RESET: "/api/auth/request-password-reset",
    RESET_PASSWORD: "/api/auth/reset-password",
    CHANGE_PASSWORD: "/api/auth/change-password",
  },
  USERS: {
    GET_ALL: "/api/user/getUsers",
    GET_ROLES: "/api/user/rol",
    CREATE: "/api/user",
    GET_BY_ID: "/api/user",
    UPDATE: "/api/user",
    DEACTIVATE: "/api/user/deactivate",
    ACTIVATE: "/api/user/activate",
    GET_COMPANIES: "/api/user/getCompaniesByUserId",
  },
  CLIENTS: {
    GET_ALL: "/api/tango/client",
    SYNC_CLIENTS: "/api/tango/sync/update",
    GET_ALL_MULTI_SELECT: "/api/clients",
    GET_BY_ID: (clientId: string) =>
      `/api/clients/getById?clientId=${clientId}`,
    /** Clientes filtrados por tipo de cliente */
    GET_BY_TYPE: "/api/clients/GetByType",
  },
  SYNC: {
    GET_NOTIFICATIONS: "/api/tango/sync/getNotification",
  },
  PRODUCTS: {
    GET_ALL: "/api/tango/product",
    SYNC_PRODUCTS: "/api/tango/sync/update",
    GET_ALL_PRODUCT_TYPE: "/api/products/GetAllProductType",
    /** Listado con filtro por tipo (cupos / clasificación) */
    GET_LIST: "/api/products",
    /** Productos por cliente (pedidos / picker) */
    GET_ALL_BY_CLIENT_ID_ASYNC: "/api/products/GetAllByClientIdAsync",
  },
  SOCIETIES: {
    GET_ALL: "/api/company/getCompanies",
    CREATE: "/api/company",
    GET_BY_ID: "/api/company",
    DEACTIVATE: "/api/company/deactivate",
    ACTIVATE: "/api/company/activate",
    UPDATE: "/api/company",
  },
  LOGS: {
    GET_ALL: "/api/logs",
  },
  REPORTS: {
    GET_ALL: "/api/reports",
    EXECUTE: (reportId: number) => `/api/reports/${reportId}/execute`,
    EXPORT: (reportId: number) => `/api/reports/${reportId}/export`,
  },
  STOCKS: {
    GET_ALL: "/api/stock/getAll",
    CREATE: "/api/stock",
    GET_BY_ID: "/api/stock/getStockHeaderById",
    DEACTIVATE: "/api/stock/deactivate",
    ACTIVATE: "/api/stock/activate",
    UPDATE: "/api/stock/updateStockHeaader",
    UPDATE_ITEMS: "/api/stock/updateStockItems",
    GET_STATUSES: "/api/stock/status",
    GET_HISTORY: "/api/stock/getHistory",
    GET_HISTORY_ITEM: "/api/stock/getItemHistory",
    GET_ITEMS: "/api/stock/getItems",
    GET_ORDER_ID: "/api/orders/getOrderId",
    CANCEL: "/api/stock/changeToCancelStock",
    ARRIVED: "/api/stock/changeToArrivedStock",
  },
  CUPOS: {
    GET_ALL_TIPOS: "/api/GetAllTipos",
    GET_ALL_TIPOS_CLIENTE: "/api/clients/GetAllTypes",
    GET_ALL_POR_PRODUCTO: "/api/classification/getProductsClassification",
    GET_ALL_POR_CLIENTE: "/api/classification/getClientsClassification",
    INSERT_BY_PRODUCT: "/api/classification/insertByProduct",
    INSERT_BY_CLIENT: "/api/classification/insertByClient",
    DELETE_BY_PRODUCT: "/api/classification/deleteByProduct",
    DELETE_BY_CLIENT: "/api/classification/deleteByClient",
  },
  ORDERS: {
    GET_ALL: "/api/orders/getAll",
    GET_FORM: "/api/orders",
    POST_ORDER: "/api/orders",
    GET_PRODUCT_TYPES: "/api/orders/getProductTypes",
    GET_DETAILS: "/api/orders/getDetails",
    SENT: "/api/orders/sent",
    SAVE_PRODUCTS: "/api/orders/saveProducts",
    DELETE_DETAIL: "/api/orders/deleteDetail",
    EXPORT: (orderId: string) => `/api/orders/${orderId}/export`,
  },
};
